import InputField from "components/fields/InputField";
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import  dataService from "../../service/dataService"
import { getFirebaseErrorMessage } from "../../utils/getFirebaseErrorMessage"

export default function SignIn() {
    localStorage.clear();
     const [email, setEmail] = useState<string>('');
     const [password, setPassword] = useState<string>('');
     const [emailError, setEmailError] = useState(false);
     const [passwordError, setPasswordError] = useState(false);
     const [isFormValid, setIsFormValid] = useState(false);
     const [error, setError] = useState(null);
     const navigate = useNavigate();
     const handleSignIn = async (e: React.FormEvent) => {
     e.preventDefault();
     if (isFormValid) {
      try {
        const userCredential = await dataService.signInWithEmailAndPassword(email, password);
          // Handle successful sign-in (e.g., redirect to dashboard)
        localStorage.setItem("currentUser",userCredential.user.email);
        navigate('/admin/default');
      } catch (error) {
        console.error("Error signing in:", error);
        const userFriendlyMessage = getFirebaseErrorMessage(error);
        setError(userFriendlyMessage);
        // Handle sign-in error (e.g., show error message)
      }
    } 
  };

  const handleForgotPassword = (event:any) => {
    event.preventDefault();
    navigate('/auth/forgot'); // Navigate to '/success-page' after submission
  };

  useEffect(() => {
    // Validate email
    setEmailError(email.includes('@') && email.length > 0);
  }, [email]);

  useEffect(() => {
    // Validate password (example: at least 6 characters)
    setPasswordError(password.length >= 6);
  }, [password]);

  useEffect(() => {
    // Update overall form validity
   setIsFormValid(emailError && passwordError);
  }, [emailError, passwordError]);

  return (
    <div className="mt-16 mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start">
      {/* Sign in section */}
      <div className="mt-[10vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
        <h4 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">
          Sign In
        </h4>
        <p className="mb-9 ml-1 text-base text-gray-600">
          Enter your email and password to sign in! 
        </p>
         {error && <div style={{ color: 'red' }}>{error}</div>}
          {/* Email */}
             <InputField
                type="email"
                id="email"
                label="Email"
                extra=""
                placeholder="Enter your email"
                variant="auth"
                value={email}
                onchange={(e) => setEmail(e.target.value)}
                //onblur={() => setEmailError(validateEmail(email))}
                required
                />
              {!emailError && email.length > 0 && <p className="mb-2 ml-3 text-base" style={{ color: 'red' }}>Please enter a valid email.</p>}
              {/* password */}
              <InputField
                type="password"
                id="password"
                label="Password"
                extra=""
                placeholder="Enter your password"
                variant="auth"
                value={password}
                onchange={(e) => setPassword(e.target.value)}
                //onblur={() => setPasswordError(validatePassword(password))}
                required
              />
              {!passwordError && password.length > 0 && <p className="mb-2 ml-3 text-base" style={{ color: 'red' }}>Password must be at least 6 characters.</p>}
                   
        {/* Checkbox */}
        <div className="mb-4 flex items-center justify-between px-2">
          <a
            className="text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-white"
            href=" " onClick={handleForgotPassword}
          >
            Forgot Password?
          </a>
        </div>

      {/* Sign In Button */}        
      <button
        type="button"
        disabled={!isFormValid}
        onClick={handleSignIn}
        className="px-4 py-2 w-full bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed">
         Sign In
      </button>
     </div>
    </div>
  );
}
